/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type BackofficeUserManagementResetMfaBackofficeUserMutationVariables =
  Types.Exact<{
    input: Types.BackofficeUserManagementResetMfaBackofficeUserInput
  }>

export type BackofficeUserManagementResetMfaBackofficeUserMutation = {
  __typename?: 'Mutation'
  backofficeUserManagementResetMfaBackofficeUser: string
}

export const BackofficeUserManagementResetMfaBackofficeUserDocument = gql`
    mutation BackofficeUserManagementResetMfaBackofficeUser($input: BackofficeUserManagementResetMfaBackofficeUserInput!) {
  backofficeUserManagementResetMfaBackofficeUser(input: $input)
}
    `
export type BackofficeUserManagementResetMfaBackofficeUserMutationFn =
  Apollo.MutationFunction<
    BackofficeUserManagementResetMfaBackofficeUserMutation,
    BackofficeUserManagementResetMfaBackofficeUserMutationVariables
  >

/**
 * __useBackofficeUserManagementResetMfaBackofficeUserMutation__
 *
 * To run a mutation, you first call `useBackofficeUserManagementResetMfaBackofficeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBackofficeUserManagementResetMfaBackofficeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [backofficeUserManagementResetMfaBackofficeUserMutation, { data, loading, error }] = useBackofficeUserManagementResetMfaBackofficeUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBackofficeUserManagementResetMfaBackofficeUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    BackofficeUserManagementResetMfaBackofficeUserMutation,
    BackofficeUserManagementResetMfaBackofficeUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    BackofficeUserManagementResetMfaBackofficeUserMutation,
    BackofficeUserManagementResetMfaBackofficeUserMutationVariables
  >(BackofficeUserManagementResetMfaBackofficeUserDocument, options)
}
export type BackofficeUserManagementResetMfaBackofficeUserMutationHookResult =
  ReturnType<typeof useBackofficeUserManagementResetMfaBackofficeUserMutation>
export type BackofficeUserManagementResetMfaBackofficeUserMutationResult =
  Apollo.MutationResult<BackofficeUserManagementResetMfaBackofficeUserMutation>
export type BackofficeUserManagementResetMfaBackofficeUserMutationOptions =
  Apollo.BaseMutationOptions<
    BackofficeUserManagementResetMfaBackofficeUserMutation,
    BackofficeUserManagementResetMfaBackofficeUserMutationVariables
  >
